import { render, staticRenderFns } from "./customSidebar.vue?vue&type=template&id=f0a751ba&scoped=true"
import script from "./customSidebar.vue?vue&type=script&lang=js"
export * from "./customSidebar.vue?vue&type=script&lang=js"
import style0 from "./customSidebar.vue?vue&type=style&index=0&id=f0a751ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a751ba",
  null
  
)

export default component.exports